import type { RawSmtpSettings, SmtpSettings } from "@/types";

export function mapToRawSmtpSettings(smtpSettings: SmtpSettings): RawSmtpSettings {
  return {
    from_name: smtpSettings.fromName,
    email_address: smtpSettings.emailAddress,
    smtp_server: smtpSettings.smtpServer,
    username: smtpSettings.username,
    password: smtpSettings.password,
    encryption_type: smtpSettings.encryptionType,
    port_number: smtpSettings.portNumber ? parseInt(smtpSettings.portNumber) : 0
  };
}